import { AxiosResponse } from "axios";
import { PERSON_APIS } from "../../api/apis";
import { get } from "../AxiosAPI";
import { Relation } from "../types";

export type Person = {
  newAadhaarNumber?: number | undefined;
  name: string;
  externalId: number | undefined;
  dob: string | undefined;
  qualification: string | undefined;
  occupation: string | undefined;
  monthlyIncome: number | undefined;
  mobileNo: number | undefined;
  email: string | undefined;
  relation?: string | undefined;
  guardian?: boolean | undefined;
  emergency?: boolean | undefined;
};

export const getPersonByAadhaarNo = (aadhaarNumber: string): Promise<AxiosResponse> => {
  return get(PERSON_APIS.GET_BY_AADHAAR_NO.replace("aadhaarNumber_value", aadhaarNumber), null);
};

export const getPersonByMobile = (mobileNo: number): Promise<AxiosResponse> => {
  return get(PERSON_APIS.GET_BY_MOBILE_NO.replace("mobile_value", "" + mobileNo), null);
};

export function getInitialPersonData(): Person {
  return {
    newAadhaarNumber: undefined,
    name: "",
    externalId: undefined,
    dob: undefined,
    qualification: "",
    occupation: "",
    monthlyIncome: undefined,
    mobileNo: undefined,
    email: "",
    relation: undefined,
    guardian: false,
    emergency: false,
  };
}

export function getPersonData(mobileNo: number): Person {
  return {
    newAadhaarNumber: undefined,
    name: "",
    externalId: undefined,
    dob: "",
    qualification: "",
    occupation: "",
    monthlyIncome: undefined,
    mobileNo: mobileNo,
    email: "",
    relation: undefined,
    guardian: undefined,
    emergency: undefined,
  };
}
export function getPersonDataWithAadhaarNo(aadhaarNo: number): Person {
  return {
    newAadhaarNumber: undefined,
    name: "",
    externalId: aadhaarNo,
    dob: "",
    qualification: "",
    occupation: "",
    monthlyIncome: undefined,
    mobileNo: undefined,
    email: "",
    relation: undefined,
    guardian: undefined,
    emergency: undefined,
  };
}
